import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enStudent from './locales/en/student.json';
import enAdmin from './locales/en/admin.json';
import esCommon from './locales/es/common.json';
import esLanding from './locales/es/landing.json';
import esStudent from './locales/es/student.json';
import esAdmin from './locales/es/admin.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        landing: enLanding,
        student: enStudent,
        admin: enAdmin,
      },
      es: {
        common: esCommon,
        landing: esLanding,
        student: esStudent,
        admin: esAdmin,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'landing', 'student', 'admin'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Sync HTML lang attribute with current language
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
// Set initial lang
document.documentElement.lang = i18n.language || 'en';

export default i18n;
